
const dayMapping = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado'
];
const monthMapping = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];

export function Calendario({ date }: { date: string }) {

    const year = date.split('/')[2];
    const month = parseInt(date.split('/')[1]);
    const monthString = monthMapping[month - 1];
    const day = date.split('/')[0];


    return (
        <div className="flex flex-col h-full px-8">
            <div className="flex flex-col w-full border rounded-3xl shadow-md">
                <div className="flex w-full h-10 rounded-t-3xl bg-rodrimaq-red-medium justify-end pr-5 font-bold text-white items-center">
                    {year}
                </div>
                <div className="flex w-full justify-center mt-4 font-bold">{dayMapping[new Date(Date.now()).getDay()]}</div>
                <div className="flex w-full justify-center text-[3em] mt-2 font-bold leading-none">{day}</div>
                <div className="flex w-full justify-end text-lg p-3 font-bold">{monthString}</div>
            </div>
        </div>
    )


}